import React from "react"
import { Header } from "semantic-ui-react"

const Error503 = ({ message }) => {
	return (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center"
			}}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					height: "80vh"
				}}
			>
				<Header style={{ textAlign: "center", color: "white", fontSize: "80pt" }}>503</Header>
				<div style={{ textAlign: "center" }}>
					<div style={{ fontSize: "25pt", fontWeight: "bold" }}>{message ? message : "Temporary Outage"}</div>
				</div>
			</div>
		</div>
	)
}
export default Error503
